const attrs = [
  '',
  '-ext',
  '-path'
]

const loader = viewport => {
  // cache images to load
  const nodes = [...document.querySelectorAll('[data-load]')]

  // cache number of images remaining
  let remaining = nodes.length

  // define change handler
  const handleChange = (entries, observer) => entries.forEach(entry => {
    // exit early if not intersecting
    if (!entry.isIntersecting) return

    // stop watching
    observer.unobserve(entry.target)

    // check WebP support
    const supportsWebP = document.body.classList.contains('webp')

    // determine size to load
    let size

    if (viewport.width < 768)  size = 'small'
    if (viewport.width >= 768) size = 'large'

    // determine retina
    const dpr = window.devicePixelRatio >= 2
      ? '-2x'
      : ''

    // determine extension
    const extension = supportsWebP
      ? 'webp'
      : entry.target.getAttribute('data-load-ext')

    // build path to image
    const base = entry.target.getAttribute('data-load-path')
    const path = `${ base }-${ size }${ dpr }.${ extension }`

    // create image node
    const image = document.createElement('img')

    // define image load handler
    const handleLoad = event => {
      // set background image
      entry.target.style.backgroundImage = `url("${ path }")`

      // cleanup data attributes
      attrs.forEach(attr => entry.target.removeAttribute(`data-load${ attr }`))

      // add loaded class
      window.requestAnimationFrame(() => entry.target.classList.add('is-loaded'))
    }

    // bind image load event
    image.addEventListener('load', handleLoad)

    // set image source
    image.setAttribute('src', path)

    // decremement remaining images
    remaining -= 1

    // if all images are loaded
    if (remaining !== 0) return

    // kill observer
    observer.disconnect()
  })

  // create observer
  const observer = new window.IntersectionObserver(handleChange, {
    root: null,
    rootMargin: `0px 0px 0px 0px`,
    threshold: .01
  })

  // add nodes to observer
  nodes.forEach(node => observer.observe(node))
}

export default loader
